import { constants } from '../../../constants/constants';
import {lazyReload} from "../../../lazyReload";
const MonitoringPage = lazyReload(() => import('../../../../managers/monitoring/Monitoring'));

export const Monitoring = [
    {path: `/${constants.pages.monitoringUrl}/:buildingID`, component: MonitoringPage, exact: true},
];
